import type { CustomIconProps } from '../types';

const FilledLike = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '15'}
        viewBox="0 0 16 15"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 5.13664C0 2.75587 1.9134 0.849976 4.30458 0.849976C6.1707 0.849976 7.25717 1.84717 8 2.66307C8.74283 1.84717 9.8293 0.849976 11.6954 0.849976C14.0866 0.849976 16 2.75587 16 5.13664C16 6.55601 15.5803 7.7038 14.4128 9.10023C13.2531 10.4873 11.3477 12.1291 8.37085 14.5422L8 14.85L7.6298 14.5427C4.65295 12.1296 2.74693 10.4873 1.58724 9.10023C0.419727 7.7038 0 6.55601 0 5.13664Z"
            fill="#414042"
        />
    </svg>
);

export default FilledLike;
